// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3ik8Y","author":"Table_author__1zBnG","authorImage":"Table_authorImage__33oYg","unreadRow":"Table_unreadRow__3rx3H"};